import { em } from '@mantine/core';

const APP_CONFIG = {
	QUERY_STALE_TIME: 30_000,
	QUERY_CACHE_TIME: 1_800_000,
	QUERY_RETRY: 2,
	EDIT_LOGOUT_TIME: 6,
	SIZE_PER_PAGE: 6,
	TEXTAREA_LIMIT: 200,
	NAVBAR_HEIGHT: 88,
	CREATOR_NAVIGATION_HEIGHT: 60,
	INFINITE_SCROLL_PER_PAGE: 3,
	TABLE_PAGE_SIZES: [10, 25, 50],
	MODAL_WIDTH: 528,
	Z_INDEX: {
		NOTIFICATION: 100,
		DRAWER: 104,
		OVERLAY: 50,
		MODAL: 301,
		SELECT_DROPDOWN: 302,
		SCROLL_TOP: 50,
		DRAGGED_PREVIEW: 500,
		TUTORIAL_OVERLAY: 550,
		TUTORIAL_ITEM: 555,
	},
	ROOT_FONT_SIZE: 16,
	BREAKPOINTS: {
		XS: em(576),
		SM: em(768),
		MD: em(992),
		LG: em(1200),
		XL: em(1408),
	},
	IVESTMENT_MAX_DELIVERIES: 3,
	DEFAULT_LANGUAGE: 'PL',
	AVAILABLE_CURRENCIES: ['PLN', 'EUR', 'USD'],
	COUNTRIES: [
		'Polska',
		'Ukraina',
		'Rumunia',
		'Niemcy',
		'Francja',
		'Czechy',
		'Słowacja',
		'Litwa',
		'Łotwa',
		'Estonia',
	],
	CONFIGURATION_DEFAULTS: {
		PROJECT: {
			WIDTH: 3500,
			HEIGHT: 2500,
			MIN: {
				WIDTH: 200,
				HEIGHT: 400,
			},
			MAX: {
				WIDTH: 6000,
				HEIGHT: 5000,
			},
		},
		WINDOW: { MIN_HEIGHT: 400 },
		SEGMENT: {
			WIDTH: 500,
			MIN_WIDTH: 200,
			MAX_WIDTH: 6000,
		},
		ROLLER_BOX: {
			HEIGHT: 165,
			DEPTH: 175,
			SHAFT_DIAMETER: 40,
			AVAILABLE_HEIGHTS: [165, 205, 245],
			AVAILABLE_DEPTHS: [175, 215, 255],
			AVAILABLE_SHAFT_DIAMETERS: [40, 60],
		},
		WING: {
			MIN_WIDTH: 200,
		},
		MOSQUITO_NET: {
			MAX_WIDTH: 1600,
		},
	},
	COMPANY_CONTACT: {
		EMAIL: 'info@beclever.eu',
		PHONE: '+48 61 4360 354',
	},
} as const;

export default APP_CONFIG;
